import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';

export const validateGroupEasyLink = (prefix: string, suffix: string): Promise<boolean> => {
  return cacheableRequest(`/v1/easy-link/${prefix}/${suffix}`).then(({ data }: AxiosResponse<{ valid: boolean }>) => {
    return data.valid;
  });
};
